export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '表单名称',
    dataIndex: 'label',
  },
  {
    title: '表单类型',
    dataIndex: 'type',
  },
  {
    title: '服务活动',
    dataIndex: 'name',
  },
  {
    title: '排序',
    dataIndex: 'sort',
  },
  {
    title: '状态',
    customRender: (text, record)=>{
      return record.status===0?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [

  {
    name: 'type',
    lable: '表单类型',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'service_id',
    lable: '服务活动',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'label',
    lable: '表单名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'area_index',
    lable: '分区序号',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'hint',
    lable: '表单输入提示',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },

  {
    name: 'help_tips',
    lable: '提示语',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },

  {
    name: 'edit_flag',
    lable: '是否可编辑',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'list_show_flag',
    lable: '是否显示',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'config_view',
    lable: '配置视图',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'config_data',
    lable: '配置数据',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'sort',
    lable: '排序',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
];